export const SHARE_EXPIRY_OPTIONS = [
  { label: '1d', hours: 24 },
  { label: '2d', hours: 48 },
  { label: '3d', hours: 72 },
  { label: '1w', hours: 168 },
  { label: '2w', hours: 336 },
  { label: '30d', hours: 720 },
];

export const buildShareUrl = (token) => `${window.location.origin}/share/${token}`;

export const buildBundleShareUrl = (token) => `${window.location.origin}/share-bundle/${token}`;

export const formatShareExpiry = (iso) => (iso ? new Date(iso).toLocaleString() : '');

export const SHARE_STATUS = {
  ACTIVE: 'Active',
  EXPIRED: 'Expired',
};

export const getShareStatusColor = (status) =>
  status === SHARE_STATUS.ACTIVE
    ? 'success'
    : status === SHARE_STATUS.EXPIRED
    ? 'default'
    : 'error';

export const buildShareBlobUrl = (data) => {
  const bytes = new Uint8Array(data.buffer?.data || []);

  return URL.createObjectURL(new Blob([bytes], { type: data.type }));
};
